import { render, staticRenderFns } from "./gateway.vue?vue&type=template&id=6c5bfa0e&"
import script from "./gateway.vue?vue&type=script&lang=js&"
export * from "./gateway.vue?vue&type=script&lang=js&"
import style0 from "./gateway.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports